var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripeSIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17953 5.36044C5.17953 4.58901 5.83465 4.29231 6.91969 4.29231C8.47559 4.29231 10.4409 4.74725 11.9969 5.55824V0.90989C10.2976 0.257143 8.6189 0 6.91969 0C2.76378 0 0 2.0967 0 5.5978C0 11.0571 7.77953 10.1868 7.77953 12.5407C7.77953 13.4505 6.96063 13.7473 5.81417 13.7473C4.11496 13.7473 1.94488 13.0747 0.225197 12.1648V16.8725C2.12913 17.6637 4.05354 18 5.81417 18C10.0724 18 13 15.9626 13 12.422C12.9795 6.52747 5.17953 7.57582 5.17953 5.36044Z",
    fill: "#635BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeSIcon);
export default __webpack_public_path__ + "static/media/stripe-s-icon.bae21da4a81a94a681426cede18370e6.svg";
export { ForwardRef as ReactComponent };